/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApplicationDocumentResponseBaseResponse as ModelsV3ApplicationApplicationDocumentResponseBaseResponse } from '../models/Models/v3/Application/application-document-response-base-response';
import { ApplicationQuoteResponseBaseResponse as ModelsV3ApplicationApplicationQuoteResponseBaseResponse } from '../models/Models/v3/Application/application-quote-response-base-response';
import { ApplicationSyncRequestBaseResponse as ModelsV3ApplicationApplicationSyncRequestBaseResponse } from '../models/Models/v3/Application/application-sync-request-base-response';
import { DtoInsuranceProductListBaseResponse as ModelsV3InsuranceDtoInsuranceProductListBaseResponse } from '../models/Models/v3/Insurance/dto-insurance-product-list-base-response';
import { DtoVehicleBaseResponse as ModelsV3VehicleDtoVehicleBaseResponse } from '../models/Models/v3/Vehicle/dto-vehicle-base-response';
import { v3ApplicationsApplicationIdInsuranceProductsPost$Json$Json } from '../fn/applications/v-3-applications-application-id-insurance-products-post-json-json';
import { V3ApplicationsApplicationIdInsuranceProductsPost$Json$Json$Params } from '../fn/applications/v-3-applications-application-id-insurance-products-post-json-json';
import { v3ApplicationsApplicationIdInsuranceProductsPost$Json$Plain } from '../fn/applications/v-3-applications-application-id-insurance-products-post-json-plain';
import { V3ApplicationsApplicationIdInsuranceProductsPost$Json$Plain$Params } from '../fn/applications/v-3-applications-application-id-insurance-products-post-json-plain';
import { v3ApplicationsApplicationIdInsuranceProductsPost$Json$Xml } from '../fn/applications/v-3-applications-application-id-insurance-products-post-json-xml';
import { V3ApplicationsApplicationIdInsuranceProductsPost$Json$Xml$Params } from '../fn/applications/v-3-applications-application-id-insurance-products-post-json-xml';
import { v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Json } from '../fn/applications/v-3-applications-application-id-insurance-products-post-xml-json';
import { V3ApplicationsApplicationIdInsuranceProductsPost$Xml$Json$Params } from '../fn/applications/v-3-applications-application-id-insurance-products-post-xml-json';
import { v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain } from '../fn/applications/v-3-applications-application-id-insurance-products-post-xml-plain';
import { V3ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain$Params } from '../fn/applications/v-3-applications-application-id-insurance-products-post-xml-plain';
import { v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml } from '../fn/applications/v-3-applications-application-id-insurance-products-post-xml-xml';
import { V3ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml$Params } from '../fn/applications/v-3-applications-application-id-insurance-products-post-xml-xml';
import { v3ApplicationsApplicationIdInsuranceQuotePost$Json$Json } from '../fn/applications/v-3-applications-application-id-insurance-quote-post-json-json';
import { V3ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Params } from '../fn/applications/v-3-applications-application-id-insurance-quote-post-json-json';
import { v3ApplicationsApplicationIdInsuranceQuotePost$Json$Plain } from '../fn/applications/v-3-applications-application-id-insurance-quote-post-json-plain';
import { V3ApplicationsApplicationIdInsuranceQuotePost$Json$Plain$Params } from '../fn/applications/v-3-applications-application-id-insurance-quote-post-json-plain';
import { v3ApplicationsApplicationIdInsuranceQuotePost$Json$Xml } from '../fn/applications/v-3-applications-application-id-insurance-quote-post-json-xml';
import { V3ApplicationsApplicationIdInsuranceQuotePost$Json$Xml$Params } from '../fn/applications/v-3-applications-application-id-insurance-quote-post-json-xml';
import { v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Json } from '../fn/applications/v-3-applications-application-id-insurance-quote-post-xml-json';
import { V3ApplicationsApplicationIdInsuranceQuotePost$Xml$Json$Params } from '../fn/applications/v-3-applications-application-id-insurance-quote-post-xml-json';
import { v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain } from '../fn/applications/v-3-applications-application-id-insurance-quote-post-xml-plain';
import { V3ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain$Params } from '../fn/applications/v-3-applications-application-id-insurance-quote-post-xml-plain';
import { v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml } from '../fn/applications/v-3-applications-application-id-insurance-quote-post-xml-xml';
import { V3ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml$Params } from '../fn/applications/v-3-applications-application-id-insurance-quote-post-xml-xml';
import { v3ApplicationsApplicationIdNotifyDealerPost } from '../fn/applications/v-3-applications-application-id-notify-dealer-post';
import { V3ApplicationsApplicationIdNotifyDealerPost$Params } from '../fn/applications/v-3-applications-application-id-notify-dealer-post';
import { v3ApplicationsApplicationIdPut$Json$Json } from '../fn/applications/v-3-applications-application-id-put-json-json';
import { V3ApplicationsApplicationIdPut$Json$Json$Params } from '../fn/applications/v-3-applications-application-id-put-json-json';
import { v3ApplicationsApplicationIdPut$Json$Plain } from '../fn/applications/v-3-applications-application-id-put-json-plain';
import { V3ApplicationsApplicationIdPut$Json$Plain$Params } from '../fn/applications/v-3-applications-application-id-put-json-plain';
import { v3ApplicationsApplicationIdPut$Json$Xml } from '../fn/applications/v-3-applications-application-id-put-json-xml';
import { V3ApplicationsApplicationIdPut$Json$Xml$Params } from '../fn/applications/v-3-applications-application-id-put-json-xml';
import { v3ApplicationsApplicationIdPut$Xml$Json } from '../fn/applications/v-3-applications-application-id-put-xml-json';
import { V3ApplicationsApplicationIdPut$Xml$Json$Params } from '../fn/applications/v-3-applications-application-id-put-xml-json';
import { v3ApplicationsApplicationIdPut$Xml$Plain } from '../fn/applications/v-3-applications-application-id-put-xml-plain';
import { V3ApplicationsApplicationIdPut$Xml$Plain$Params } from '../fn/applications/v-3-applications-application-id-put-xml-plain';
import { v3ApplicationsApplicationIdPut$Xml$Xml } from '../fn/applications/v-3-applications-application-id-put-xml-xml';
import { V3ApplicationsApplicationIdPut$Xml$Xml$Params } from '../fn/applications/v-3-applications-application-id-put-xml-xml';
import { v3ApplicationsApplicationIdVehicleGet$Json } from '../fn/applications/v-3-applications-application-id-vehicle-get-json';
import { V3ApplicationsApplicationIdVehicleGet$Json$Params } from '../fn/applications/v-3-applications-application-id-vehicle-get-json';
import { v3ApplicationsApplicationIdVehicleGet$Plain } from '../fn/applications/v-3-applications-application-id-vehicle-get-plain';
import { V3ApplicationsApplicationIdVehicleGet$Plain$Params } from '../fn/applications/v-3-applications-application-id-vehicle-get-plain';
import { v3ApplicationsApplicationIdVehicleGet$Xml } from '../fn/applications/v-3-applications-application-id-vehicle-get-xml';
import { V3ApplicationsApplicationIdVehicleGet$Xml$Params } from '../fn/applications/v-3-applications-application-id-vehicle-get-xml';
import { v3ApplicationsDocumentsCombinePost$Json$Json } from '../fn/applications/v-3-applications-documents-combine-post-json-json';
import { V3ApplicationsDocumentsCombinePost$Json$Json$Params } from '../fn/applications/v-3-applications-documents-combine-post-json-json';
import { v3ApplicationsDocumentsCombinePost$Json$Plain } from '../fn/applications/v-3-applications-documents-combine-post-json-plain';
import { V3ApplicationsDocumentsCombinePost$Json$Plain$Params } from '../fn/applications/v-3-applications-documents-combine-post-json-plain';
import { v3ApplicationsDocumentsCombinePost$Xml$Json } from '../fn/applications/v-3-applications-documents-combine-post-xml-json';
import { V3ApplicationsDocumentsCombinePost$Xml$Json$Params } from '../fn/applications/v-3-applications-documents-combine-post-xml-json';
import { v3ApplicationsDocumentsCombinePost$Xml$Plain } from '../fn/applications/v-3-applications-documents-combine-post-xml-plain';
import { V3ApplicationsDocumentsCombinePost$Xml$Plain$Params } from '../fn/applications/v-3-applications-documents-combine-post-xml-plain';
import { v3ApplicationsDocumentsSummaryGet$Json } from '../fn/applications/v-3-applications-documents-summary-get-json';
import { V3ApplicationsDocumentsSummaryGet$Json$Params } from '../fn/applications/v-3-applications-documents-summary-get-json';
import { v3ApplicationsDocumentsSummaryGet$Plain } from '../fn/applications/v-3-applications-documents-summary-get-plain';
import { V3ApplicationsDocumentsSummaryGet$Plain$Params } from '../fn/applications/v-3-applications-documents-summary-get-plain';
import { v3ApplicationsDocumentsSummaryGet$Xml } from '../fn/applications/v-3-applications-documents-summary-get-xml';
import { V3ApplicationsDocumentsSummaryGet$Xml$Params } from '../fn/applications/v-3-applications-documents-summary-get-xml';
import { v3ApplicationsVehicleGet$Json } from '../fn/applications/v-3-applications-vehicle-get-json';
import { V3ApplicationsVehicleGet$Json$Params } from '../fn/applications/v-3-applications-vehicle-get-json';
import { v3ApplicationsVehicleGet$Plain } from '../fn/applications/v-3-applications-vehicle-get-plain';
import { V3ApplicationsVehicleGet$Plain$Params } from '../fn/applications/v-3-applications-vehicle-get-plain';
import { v3ApplicationsVehicleGet$Xml } from '../fn/applications/v-3-applications-vehicle-get-xml';
import { V3ApplicationsVehicleGet$Xml$Params } from '../fn/applications/v-3-applications-vehicle-get-xml';
import { v3CustomersAdminAppNotificationsPost$Json } from '../fn/applications/v-3-customers-admin-app-notifications-post-json';
import { V3CustomersAdminAppNotificationsPost$Json$Params } from '../fn/applications/v-3-customers-admin-app-notifications-post-json';
import { v3CustomersAdminAppNotificationsPost$Xml } from '../fn/applications/v-3-customers-admin-app-notifications-post-xml';
import { V3CustomersAdminAppNotificationsPost$Xml$Params } from '../fn/applications/v-3-customers-admin-app-notifications-post-xml';

@Injectable({ providedIn: 'root' })
export class ApplicationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v3ApplicationsApplicationIdVehicleGet()` */
  static readonly V3ApplicationsApplicationIdVehicleGetPath = '/v3/applications/{applicationId}/vehicle';

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdVehicleGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsApplicationIdVehicleGet$Plain$Response(params: V3ApplicationsApplicationIdVehicleGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>> {
    return v3ApplicationsApplicationIdVehicleGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdVehicleGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsApplicationIdVehicleGet$Plain(params: V3ApplicationsApplicationIdVehicleGet$Plain$Params, context?: HttpContext): Observable<ModelsV3VehicleDtoVehicleBaseResponse> {
    return this.v3ApplicationsApplicationIdVehicleGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>): ModelsV3VehicleDtoVehicleBaseResponse => r.body)
    );
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdVehicleGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsApplicationIdVehicleGet$Json$Response(params: V3ApplicationsApplicationIdVehicleGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>> {
    return v3ApplicationsApplicationIdVehicleGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdVehicleGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsApplicationIdVehicleGet$Json(params: V3ApplicationsApplicationIdVehicleGet$Json$Params, context?: HttpContext): Observable<ModelsV3VehicleDtoVehicleBaseResponse> {
    return this.v3ApplicationsApplicationIdVehicleGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>): ModelsV3VehicleDtoVehicleBaseResponse => r.body)
    );
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdVehicleGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsApplicationIdVehicleGet$Xml$Response(params: V3ApplicationsApplicationIdVehicleGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>> {
    return v3ApplicationsApplicationIdVehicleGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdVehicleGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsApplicationIdVehicleGet$Xml(params: V3ApplicationsApplicationIdVehicleGet$Xml$Params, context?: HttpContext): Observable<ModelsV3VehicleDtoVehicleBaseResponse> {
    return this.v3ApplicationsApplicationIdVehicleGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>): ModelsV3VehicleDtoVehicleBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3ApplicationsVehicleGet()` */
  static readonly V3ApplicationsVehicleGetPath = '/v3/applications/vehicle';

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsVehicleGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsVehicleGet$Plain$Response(params: V3ApplicationsVehicleGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>> {
    return v3ApplicationsVehicleGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsVehicleGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsVehicleGet$Plain(params: V3ApplicationsVehicleGet$Plain$Params, context?: HttpContext): Observable<ModelsV3VehicleDtoVehicleBaseResponse> {
    return this.v3ApplicationsVehicleGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>): ModelsV3VehicleDtoVehicleBaseResponse => r.body)
    );
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsVehicleGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsVehicleGet$Json$Response(params: V3ApplicationsVehicleGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>> {
    return v3ApplicationsVehicleGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsVehicleGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsVehicleGet$Json(params: V3ApplicationsVehicleGet$Json$Params, context?: HttpContext): Observable<ModelsV3VehicleDtoVehicleBaseResponse> {
    return this.v3ApplicationsVehicleGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>): ModelsV3VehicleDtoVehicleBaseResponse => r.body)
    );
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsVehicleGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsVehicleGet$Xml$Response(params: V3ApplicationsVehicleGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>> {
    return v3ApplicationsVehicleGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsVehicleGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsVehicleGet$Xml(params: V3ApplicationsVehicleGet$Xml$Params, context?: HttpContext): Observable<ModelsV3VehicleDtoVehicleBaseResponse> {
    return this.v3ApplicationsVehicleGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>): ModelsV3VehicleDtoVehicleBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3ApplicationsApplicationIdNotifyDealerPost()` */
  static readonly V3ApplicationsApplicationIdNotifyDealerPostPath = '/v3/applications/{applicationId}/notify-dealer';

  /**
   * NotifyDealer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdNotifyDealerPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdNotifyDealerPost$Response(params: V3ApplicationsApplicationIdNotifyDealerPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v3ApplicationsApplicationIdNotifyDealerPost(this.http, this.rootUrl, params, context);
  }

  /**
   * NotifyDealer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdNotifyDealerPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdNotifyDealerPost(params: V3ApplicationsApplicationIdNotifyDealerPost$Params, context?: HttpContext): Observable<void> {
    return this.v3ApplicationsApplicationIdNotifyDealerPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `v3ApplicationsApplicationIdInsuranceProductsPost()` */
  static readonly V3ApplicationsApplicationIdInsuranceProductsPostPath = '/v3/applications/{applicationId}/insurance/products';

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdInsuranceProductsPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdInsuranceProductsPost$Json$Plain$Response(params: V3ApplicationsApplicationIdInsuranceProductsPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>> {
    return v3ApplicationsApplicationIdInsuranceProductsPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdInsuranceProductsPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdInsuranceProductsPost$Json$Plain(params: V3ApplicationsApplicationIdInsuranceProductsPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3InsuranceDtoInsuranceProductListBaseResponse> {
    return this.v3ApplicationsApplicationIdInsuranceProductsPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>): ModelsV3InsuranceDtoInsuranceProductListBaseResponse => r.body)
    );
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdInsuranceProductsPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdInsuranceProductsPost$Json$Json$Response(params: V3ApplicationsApplicationIdInsuranceProductsPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>> {
    return v3ApplicationsApplicationIdInsuranceProductsPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdInsuranceProductsPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdInsuranceProductsPost$Json$Json(params: V3ApplicationsApplicationIdInsuranceProductsPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV3InsuranceDtoInsuranceProductListBaseResponse> {
    return this.v3ApplicationsApplicationIdInsuranceProductsPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>): ModelsV3InsuranceDtoInsuranceProductListBaseResponse => r.body)
    );
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdInsuranceProductsPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdInsuranceProductsPost$Json$Xml$Response(params: V3ApplicationsApplicationIdInsuranceProductsPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>> {
    return v3ApplicationsApplicationIdInsuranceProductsPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdInsuranceProductsPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdInsuranceProductsPost$Json$Xml(params: V3ApplicationsApplicationIdInsuranceProductsPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3InsuranceDtoInsuranceProductListBaseResponse> {
    return this.v3ApplicationsApplicationIdInsuranceProductsPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>): ModelsV3InsuranceDtoInsuranceProductListBaseResponse => r.body)
    );
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain$Response(params: V3ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>> {
    return v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain(params: V3ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3InsuranceDtoInsuranceProductListBaseResponse> {
    return this.v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>): ModelsV3InsuranceDtoInsuranceProductListBaseResponse => r.body)
    );
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Json$Response(params: V3ApplicationsApplicationIdInsuranceProductsPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>> {
    return v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Json(params: V3ApplicationsApplicationIdInsuranceProductsPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3InsuranceDtoInsuranceProductListBaseResponse> {
    return this.v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>): ModelsV3InsuranceDtoInsuranceProductListBaseResponse => r.body)
    );
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml$Response(params: V3ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>> {
    return v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml(params: V3ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3InsuranceDtoInsuranceProductListBaseResponse> {
    return this.v3ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>): ModelsV3InsuranceDtoInsuranceProductListBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3ApplicationsApplicationIdInsuranceQuotePost()` */
  static readonly V3ApplicationsApplicationIdInsuranceQuotePostPath = '/v3/applications/{applicationId}/insurance/quote';

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdInsuranceQuotePost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdInsuranceQuotePost$Json$Plain$Response(params: V3ApplicationsApplicationIdInsuranceQuotePost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>> {
    return v3ApplicationsApplicationIdInsuranceQuotePost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdInsuranceQuotePost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdInsuranceQuotePost$Json$Plain(params: V3ApplicationsApplicationIdInsuranceQuotePost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationQuoteResponseBaseResponse> {
    return this.v3ApplicationsApplicationIdInsuranceQuotePost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>): ModelsV3ApplicationApplicationQuoteResponseBaseResponse => r.body)
    );
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdInsuranceQuotePost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Response(params: V3ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>> {
    return v3ApplicationsApplicationIdInsuranceQuotePost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdInsuranceQuotePost$Json$Json(params: V3ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationQuoteResponseBaseResponse> {
    return this.v3ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>): ModelsV3ApplicationApplicationQuoteResponseBaseResponse => r.body)
    );
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdInsuranceQuotePost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdInsuranceQuotePost$Json$Xml$Response(params: V3ApplicationsApplicationIdInsuranceQuotePost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>> {
    return v3ApplicationsApplicationIdInsuranceQuotePost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdInsuranceQuotePost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdInsuranceQuotePost$Json$Xml(params: V3ApplicationsApplicationIdInsuranceQuotePost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationQuoteResponseBaseResponse> {
    return this.v3ApplicationsApplicationIdInsuranceQuotePost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>): ModelsV3ApplicationApplicationQuoteResponseBaseResponse => r.body)
    );
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain$Response(params: V3ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>> {
    return v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain(params: V3ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationQuoteResponseBaseResponse> {
    return this.v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>): ModelsV3ApplicationApplicationQuoteResponseBaseResponse => r.body)
    );
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Json$Response(params: V3ApplicationsApplicationIdInsuranceQuotePost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>> {
    return v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Json(params: V3ApplicationsApplicationIdInsuranceQuotePost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationQuoteResponseBaseResponse> {
    return this.v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>): ModelsV3ApplicationApplicationQuoteResponseBaseResponse => r.body)
    );
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml$Response(params: V3ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>> {
    return v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml(params: V3ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationQuoteResponseBaseResponse> {
    return this.v3ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>): ModelsV3ApplicationApplicationQuoteResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3ApplicationsApplicationIdPut()` */
  static readonly V3ApplicationsApplicationIdPutPath = '/v3/applications/{applicationId}';

  /**
   * Sync application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdPut$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdPut$Json$Plain$Response(params: V3ApplicationsApplicationIdPut$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>> {
    return v3ApplicationsApplicationIdPut$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdPut$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdPut$Json$Plain(params: V3ApplicationsApplicationIdPut$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationSyncRequestBaseResponse> {
    return this.v3ApplicationsApplicationIdPut$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>): ModelsV3ApplicationApplicationSyncRequestBaseResponse => r.body)
    );
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdPut$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdPut$Json$Json$Response(params: V3ApplicationsApplicationIdPut$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>> {
    return v3ApplicationsApplicationIdPut$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdPut$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdPut$Json$Json(params: V3ApplicationsApplicationIdPut$Json$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationSyncRequestBaseResponse> {
    return this.v3ApplicationsApplicationIdPut$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>): ModelsV3ApplicationApplicationSyncRequestBaseResponse => r.body)
    );
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdPut$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdPut$Json$Xml$Response(params: V3ApplicationsApplicationIdPut$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>> {
    return v3ApplicationsApplicationIdPut$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdPut$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsApplicationIdPut$Json$Xml(params: V3ApplicationsApplicationIdPut$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationSyncRequestBaseResponse> {
    return this.v3ApplicationsApplicationIdPut$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>): ModelsV3ApplicationApplicationSyncRequestBaseResponse => r.body)
    );
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdPut$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdPut$Xml$Plain$Response(params: V3ApplicationsApplicationIdPut$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>> {
    return v3ApplicationsApplicationIdPut$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdPut$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdPut$Xml$Plain(params: V3ApplicationsApplicationIdPut$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationSyncRequestBaseResponse> {
    return this.v3ApplicationsApplicationIdPut$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>): ModelsV3ApplicationApplicationSyncRequestBaseResponse => r.body)
    );
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdPut$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdPut$Xml$Json$Response(params: V3ApplicationsApplicationIdPut$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>> {
    return v3ApplicationsApplicationIdPut$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdPut$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdPut$Xml$Json(params: V3ApplicationsApplicationIdPut$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationSyncRequestBaseResponse> {
    return this.v3ApplicationsApplicationIdPut$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>): ModelsV3ApplicationApplicationSyncRequestBaseResponse => r.body)
    );
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsApplicationIdPut$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdPut$Xml$Xml$Response(params: V3ApplicationsApplicationIdPut$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>> {
    return v3ApplicationsApplicationIdPut$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsApplicationIdPut$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsApplicationIdPut$Xml$Xml(params: V3ApplicationsApplicationIdPut$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationSyncRequestBaseResponse> {
    return this.v3ApplicationsApplicationIdPut$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>): ModelsV3ApplicationApplicationSyncRequestBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3ApplicationsDocumentsSummaryGet()` */
  static readonly V3ApplicationsDocumentsSummaryGetPath = '/v3/applications/documents/summary';

  /**
   * Gets application documents - DocMerger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsDocumentsSummaryGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsDocumentsSummaryGet$Plain$Response(params?: V3ApplicationsDocumentsSummaryGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationDocumentResponseBaseResponse>> {
    return v3ApplicationsDocumentsSummaryGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets application documents - DocMerger.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsDocumentsSummaryGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsDocumentsSummaryGet$Plain(params?: V3ApplicationsDocumentsSummaryGet$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationDocumentResponseBaseResponse> {
    return this.v3ApplicationsDocumentsSummaryGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationDocumentResponseBaseResponse>): ModelsV3ApplicationApplicationDocumentResponseBaseResponse => r.body)
    );
  }

  /**
   * Gets application documents - DocMerger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsDocumentsSummaryGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsDocumentsSummaryGet$Json$Response(params?: V3ApplicationsDocumentsSummaryGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationDocumentResponseBaseResponse>> {
    return v3ApplicationsDocumentsSummaryGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets application documents - DocMerger.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsDocumentsSummaryGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsDocumentsSummaryGet$Json(params?: V3ApplicationsDocumentsSummaryGet$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationDocumentResponseBaseResponse> {
    return this.v3ApplicationsDocumentsSummaryGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationDocumentResponseBaseResponse>): ModelsV3ApplicationApplicationDocumentResponseBaseResponse => r.body)
    );
  }

  /**
   * Gets application documents - DocMerger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsDocumentsSummaryGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsDocumentsSummaryGet$Xml$Response(params?: V3ApplicationsDocumentsSummaryGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationDocumentResponseBaseResponse>> {
    return v3ApplicationsDocumentsSummaryGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets application documents - DocMerger.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsDocumentsSummaryGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationsDocumentsSummaryGet$Xml(params?: V3ApplicationsDocumentsSummaryGet$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationDocumentResponseBaseResponse> {
    return this.v3ApplicationsDocumentsSummaryGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationDocumentResponseBaseResponse>): ModelsV3ApplicationApplicationDocumentResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3ApplicationsDocumentsCombinePost()` */
  static readonly V3ApplicationsDocumentsCombinePostPath = '/v3/applications/documents/combine';

  /**
   * Combines a list of ApplicationDocumentResponse into a single PDF and returns it - DocMerger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsDocumentsCombinePost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsDocumentsCombinePost$Json$Plain$Response(params?: V3ApplicationsDocumentsCombinePost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return v3ApplicationsDocumentsCombinePost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Combines a list of ApplicationDocumentResponse into a single PDF and returns it - DocMerger.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsDocumentsCombinePost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsDocumentsCombinePost$Json$Plain(params?: V3ApplicationsDocumentsCombinePost$Json$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.v3ApplicationsDocumentsCombinePost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Combines a list of ApplicationDocumentResponse into a single PDF and returns it - DocMerger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsDocumentsCombinePost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsDocumentsCombinePost$Json$Json$Response(params?: V3ApplicationsDocumentsCombinePost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return v3ApplicationsDocumentsCombinePost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Combines a list of ApplicationDocumentResponse into a single PDF and returns it - DocMerger.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsDocumentsCombinePost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationsDocumentsCombinePost$Json$Json(params?: V3ApplicationsDocumentsCombinePost$Json$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.v3ApplicationsDocumentsCombinePost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Combines a list of ApplicationDocumentResponse into a single PDF and returns it - DocMerger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsDocumentsCombinePost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsDocumentsCombinePost$Xml$Plain$Response(params?: V3ApplicationsDocumentsCombinePost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return v3ApplicationsDocumentsCombinePost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Combines a list of ApplicationDocumentResponse into a single PDF and returns it - DocMerger.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsDocumentsCombinePost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsDocumentsCombinePost$Xml$Plain(params?: V3ApplicationsDocumentsCombinePost$Xml$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.v3ApplicationsDocumentsCombinePost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Combines a list of ApplicationDocumentResponse into a single PDF and returns it - DocMerger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationsDocumentsCombinePost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsDocumentsCombinePost$Xml$Json$Response(params?: V3ApplicationsDocumentsCombinePost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return v3ApplicationsDocumentsCombinePost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Combines a list of ApplicationDocumentResponse into a single PDF and returns it - DocMerger.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationsDocumentsCombinePost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationsDocumentsCombinePost$Xml$Json(params?: V3ApplicationsDocumentsCombinePost$Xml$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.v3ApplicationsDocumentsCombinePost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `v3CustomersAdminAppNotificationsPost()` */
  static readonly V3CustomersAdminAppNotificationsPostPath = '/v3/customers-admin/app-notifications';

  /**
   * Creates a notification for a given client ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersAdminAppNotificationsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersAdminAppNotificationsPost$Json$Response(params?: V3CustomersAdminAppNotificationsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v3CustomersAdminAppNotificationsPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a notification for a given client ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersAdminAppNotificationsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersAdminAppNotificationsPost$Json(params?: V3CustomersAdminAppNotificationsPost$Json$Params, context?: HttpContext): Observable<void> {
    return this.v3CustomersAdminAppNotificationsPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /**
   * Creates a notification for a given client ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersAdminAppNotificationsPost$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersAdminAppNotificationsPost$Xml$Response(params?: V3CustomersAdminAppNotificationsPost$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v3CustomersAdminAppNotificationsPost$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a notification for a given client ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersAdminAppNotificationsPost$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersAdminAppNotificationsPost$Xml(params?: V3CustomersAdminAppNotificationsPost$Xml$Params, context?: HttpContext): Observable<void> {
    return this.v3CustomersAdminAppNotificationsPost$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
